import { render, staticRenderFns } from "./DataSanksi.vue?vue&type=template&id=16480675&"
import script from "./DataSanksi.vue?vue&type=script&lang=js&"
export * from "./DataSanksi.vue?vue&type=script&lang=js&"
import style0 from "./DataSanksi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports